<template>
	<el-drawer :modal="false"  title="Credit Report Purchase Detail" :visible.sync="show_drawer" class="drawer-credit-report-detail" size="40%">
		<b-container>
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<p class="text-muted">Customer Name</p>
					<p class="font-weight-bold mb-0">{{ creditReportSummary.credit_report_cust_name }}</p>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Customer IC</p>
					<p class="font-weight-bold mb-0">{{ creditReportSummary.credit_report_cust_ic }}</p>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Customer DOB</p>
					<p class="font-weight-bold mb-0">{{ creditReportSummary.credit_report_cust_dob }}</p>
				</b-col>
			</b-row>
			<b-row align-v="center" class="py-3">
				<b-col cols="12">
					<h2 class="listing-title mb-0">Report Documents</h2>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Credit Report</p>
					<a href="javascript:void(0)" @click="showPreview(creditReportSummary.credit_report_pdf_unsigned_url)" class="font-weight-bold" 
							v-if="creditReportSummary.credit_report_pdf_unsigned_url !== ''">View</a>
					<span v-else>-</span>
				</b-col>
				<!-- <b-col cols="6">
					<p class="text-muted">Prescreening Analysis Report</p>
					<a href="javascript:void(0)" @click="showPreview(creditReportSummary.credit_report_fintscore_unsigned_url)" class="font-weight-bold" 
							v-if="creditReportSummary.credit_report_fintscore_unsigned_url !== ''">View</a>
					<span v-else>-</span>
				</b-col> -->
				<b-col cols="6">
					<p class="text-muted">Consent Form</p>
					<a href="javascript:void(0)" @click="showPreview(creditReportSummary.credit_report_consent_unsigned_url)" class="font-weight-bold" 
							v-if="creditReportSummary.credit_report_consent_unsigned_url !== ''">View</a>
					<span v-else>-</span>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Front IC</p>
					<a href="javascript:void(0)" @click="showPreview(creditReportSummary.credit_report_ic_front_unsigned_url)" class="font-weight-bold" 
							v-if="creditReportSummary.credit_report_ic_front_unsigned_url !== ''">View</a>
					<span v-else>-</span>
				</b-col>
			</b-row>
		</b-container>
	</el-drawer>
</template>
<style>
/* Targeting the el-drawer by its class */
.el-drawer__wrapper {
  z-index: 1000 !important; /* Set your desired z-index value */
}
</style>
<script>
import { Drawer } from 'element-ui'
import { useAuthStore } from '@/stores/authStore'
import { useCreditReportStore } from '@/stores/creditReportStore'
import { mapActions, mapState } from 'pinia'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce,
	swal
} from '@/assets/js/httpImports.js'
export default {
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin
	],
	components: {
		[Drawer.name]: Drawer,
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useCreditReportStore, ['creditReportSummary']),
	},
	async created() {
		
	},
	mounted() {
	},
	data() {
		return {
			show_drawer: false,
			full_detail: {}
		}
	},
	methods: {
		showDrawer() {
			this.show_drawer = !this.show_drawer;
		},
		closeDrawer() {
			this.show_drawer = false;
			this.$emit('close');
		},
		showPreview(url){
			this.$emit('show_preview', url);
		}
	}
}
</script>